import mongoose from 'mongoose';
import schema, { IMapDistanceCacheDocument } from '../schemas/map-distance-cache';

const MapDistanceCache = (mongoose.models.MapDistanceCache ||
  mongoose.model<IMapDistanceCacheDocument>('MapDistanceCache', schema)) as mongoose.Model<
  IMapDistanceCacheDocument
>;

export default MapDistanceCache;
